import { sendGTMEvent } from "@next/third-parties/google"
import { useState, useEffect, useMemo } from "react"

import { GetLoanApplicationInfoResponse, LoanApplicationState } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

const FINAL_STATES = [
  LoanApplicationState.APPROVED,
  LoanApplicationState.REJECTED,
  LoanApplicationState.NEEDS_MANUAL_REVIEW,
  LoanApplicationState.SUBMITTED,
  LoanApplicationState.APPROVED_BY_MODEL,
  LoanApplicationState.APPROVED_DP_REQUIRED,
]

export function useLoanApplicationStatus(isInitialized: boolean, isAuthenticated: boolean) {
  const [response, setResponse] = useState<GetLoanApplicationInfoResponse | null>(null)

  useEffect(() => {
    if (!isInitialized || !isAuthenticated) return

    const pollStatus = async () => {
      try {
        const response = await neloApiClient.checkLoanApplicationStatus()

        if (FINAL_STATES.includes(response.state)) {
          setResponse(response)
          clearInterval(intervalId)

          if (response.state === LoanApplicationState.APPROVED) {
            sendGTMEvent({
              event: "loan_application_approved",
            })
          }
        }
      } catch (error) {
        console.error("Error polling loan application status:", error)
      }
    }

    pollStatus() // Initial check
    const intervalId = setInterval(pollStatus, 5000)

    return () => clearInterval(intervalId)
  }, [isInitialized, isAuthenticated])

  const result = useMemo(() => {
    return response ? { status: response.state, maxCreditLimit: response.maxCreditLimit } : null
  }, [response])

  return result
}
